module.exports = __webpack_public_path__ + "img/pc_banner_rule.a5ba2eb6.jpeg";